import script from "./InvoicingDisplaySettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoicingDisplaySettings.vue?vue&type=script&setup=true&lang=ts"

import "./InvoicingDisplaySettings.vue?vue&type=style&index=0&id=fb5569a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb5569a6"]])

export default __exports__